import { logger } from '@adornis/base/logging.js';
import { alertDialog } from '@adornis/dialog/dialog-functions.js';
import type { AdornisRoleToContextsWrapper } from '@adornis/users/db/roleToContextsWrapper.js';
import type { BaseError } from '@adornis/validation/errors/BaseError.js';
import { html } from 'lit';
import { Role } from '../permissions/roles.js';
import type { Person } from '../users/entities/person.js';

export const displayMailError = (error: BaseError) => {
  logger.error(error);
  let errorMessage = error.message;
  if (error.extensions.invalidEmails?.length > 0) {
    errorMessage = `Eine oder mehrere E-Mails konnten nicht versendet werden: ${error.extensions.invalidEmails.join(
      ', ',
    )}!\nBitte stellen Sie sicher, dass sie die korrekte Adresse angegeben haben.\nEs werden nur die folgenden Domains akzeptiert: ${error.extensions.domainWhitelist.join(
      ', ',
    )}.`;
  }
  void alertDialog(html`<p class="whitespace-pre-line">${errorMessage}</p>`);
};

export function buttonDelay(milliseconds: number = 333) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

/**
 * Check if PSB can edit Schulleiter data in the same Schul
 * @param currentUser
 * @param person
 * @returns
 */
export function checkIfPSBCanEditingSchulleiterData(currentUser: Person, person: Person): boolean {
  const psb: AdornisRoleToContextsWrapper | undefined = currentUser.roles.find(role => role.name === Role.PSB);
  const schulleiter: AdornisRoleToContextsWrapper | undefined = person.roles.find(
    role => role.name === Role.SCHULLEITER,
  );
  if (!psb || !schulleiter) return true;
  return !psb.contexts.some(schulID => schulleiter.contexts.includes(schulID));
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
